import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MatPaginator, MAT_DIALOG_DATA, PageEvent } from '@angular/material';
import { Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { TipoArquivo } from 'src/app/models/enum';
import { KitImagem } from 'src/app/models/kit-imagem';
import { ModeloDownloadAnexo } from 'src/app/models/modelo-download-anexo';
import { ArquivoService } from 'src/app/services/arquivo.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { KitImagemService } from 'src/app/services/kit-imagem.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';
import { ModelosDeDownloadModalComponent } from '../modelos-de-download-modal/modelos-de-download-modal.component';
import { CadastrarKitImagemModalComponent } from './cadastrar-kit-imagem-modal/cadastrar-kit-imagem-modal.component';
import { PaginatorService } from 'src/app/services/paginator.service';

declare const $: any;

@Component({
  selector: 'app-kit-imagem-modal',
  templateUrl: './kit-imagem-modal.component.html',
  styleUrls: ['./kit-imagem-modal.component.scss']
})
export class KitImagemModalComponent implements OnInit, OnDestroy {

  // variáveis
  kitImagensFiltrados: KitImagem[] = [];
  carregando = true;
  campoOrdenacao = 'painel';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroPainel = '';
  filtroMarcaInversor = '';
  public config: PerfectScrollbarConfigInterface = {};

  @ViewChild('paginatorKitImagem', { static: false }) paginator: MatPaginator;

  constructor(private kitImagemService: KitImagemService, private utilitarioService: UtilitarioService,
    public dialog: MatDialog, private arquivoService: ArquivoService, private paginatorService: PaginatorService,
    private carregandoService: CarregandoService, private notificacaoService: NotificacaoService, 
    public dialogRef: MatDialogRef<KitImagemModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarKitImagems();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarKitImagems();
    this.paginator.firstPage();
  }

  buscarKitImagems() {
    this.carregandoService.mostra('buscaKitImagems');
    this.carregando = true;

    this.kitImagemService.consultarKitImagemsComPaginacao(this.filtroPainel, this.filtroMarcaInversor, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc').subscribe(dados => {
        this.kitImagensFiltrados = dados.itens;

        if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
          this.itensPorPagina = 10;
        }

        this.paginacao.total = dados.total;

        this.carregando = false;
        this.carregandoService.esconde('buscaKitImagems');
      }, (erro) => {
        this.carregandoService.esconde('buscaKitImagems');
        this.notificacaoService.erro(erro);
      });
  }

  novoKitImagem() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarKitImagemModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: {  },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.buscarKitImagems();
      }
    });
  }

  editarKitImagem(kitImagem: KitImagem) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarKitImagemModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: { id: kitImagem.id },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.buscarKitImagems();
      }
    });
  }

  baixarArquivo(kitImagem: KitImagem) {
    this.carregandoService.mostra('baixarArquivo');
    this.arquivoService.baixarArquivo(kitImagem.id, TipoArquivo.KitImagem).subscribe(arq => {
      this.utilitarioService.saveBlob(arq, kitImagem.imagem);
      this.carregandoService.esconde('baixarArquivo');
    }, (erro) => {
      this.carregandoService.esconde('baixarArquivo');
      this.notificacaoService.erro(erro);
    });
  }

  visualizarArquivo(anexo: KitImagem) {
    this.carregandoService.mostra('visualizarArquivo');
    this.arquivoService.baixarArquivo(anexo.id, TipoArquivo.KitImagem).subscribe(arq => {
      if (this.utilitarioService.eImagem(anexo.imagem)) {
        this.utilitarioService.mostrarImagemBlob(arq, anexo.imagem);
      }
      this.carregandoService.esconde('visualizarArquivo');
    }, (erro) => {
      this.carregandoService.esconde('visualizarArquivo');
      this.notificacaoService.erro(erro);
    });
  }

  excluirKitImagem(kitImagem: KitImagem) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir a Imagem de Kit?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluiKitImagem');
        this.kitImagemService.excluir(kitImagem.id).subscribe(resp => {

          this.notificacaoService.sucesso('Imagem de Kit excluída com sucesso!!!');
          this.carregandoService.esconde('excluiKitImagem');
          this.filtra();
        }, (erro) => {
          this.carregandoService.esconde('excluiKitImagem');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarKitImagems();
  }

  ngOnDestroy(): void {}

  fechar() {
    this.dialogRef.close();
  }
}
